export default __webpack_public_path__ + "static/media/remove.2558921a.svg";